function TrinidadAndTobago({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_2338)">
  <path d="M8.66355 1.77734C7.23117 2.51666 5.88661 3.48572 4.68586 4.68647C3.48505 5.88728 2.51598 7.23184 1.77673 8.66422L12.0647 19.936L23.3365 30.224C24.7689 29.4847 26.1135 28.5156 27.3142 27.3149C28.515 26.1141 29.484 24.7695 30.2234 23.3372L19.9354 12.0653L8.66355 1.77734Z" fill="#F0F0F0"/>
  <path d="M27.3142 27.3139C27.9853 26.6427 28.584 25.9265 29.111 25.1753L6.82441 2.88867C6.07322 3.41561 5.35704 4.01423 4.68585 4.68542C4.01466 5.35661 3.41604 6.0728 2.88904 6.82405L25.1756 29.1105C25.9267 28.5836 26.643 27.985 27.3142 27.3139Z" fill="black"/>
  <path d="M4.68574 27.3147C9.73368 32.3627 17.3147 33.3317 23.3364 30.2238L1.77668 8.66406C-1.33113 14.6857 -0.361942 22.2668 4.68574 27.3147Z" fill="#D80027"/>
  <path d="M27.3142 4.68583C22.2663 -0.36205 14.6852 -1.33105 8.66357 1.77664L30.2233 23.3365C33.3311 17.3149 32.3621 9.7337 27.3142 4.68583Z" fill="#D80027"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default TrinidadAndTobago;
